import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useToastContext from "../hooks/useToastContext";
import { updateUser } from "../redux/slices/userSlice";
import { useDispatch } from "react-redux";


import { hashObject } from "react-hash-string";

import "../style/Login.css";

const Login = () => {
  const [pass, setPass] = useState();
  const [passShow, setPassShow] = useState(false);
  const [user, setUser] = useState();

  const addToast = useToastContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const togglePass = () => setPassShow(!passShow);

  const login = (e) => {
    e.preventDefault();

    const validUsers = [
      process.env.REACT_APP_USER,
      process.env.REACT_APP_USER1,
      process.env.REACT_APP_USER2,
      process.env.REACT_APP_USER3,
    ];

    const hashedIds = validUsers.map((u) => hashObject({ user: u }));
    console.log(validUsers.includes(user));

    if (validUsers.includes(user) && pass === process.env.REACT_APP_PASS) {
      const hashedUserId = hashObject({ user: user });
      const isUserValid = hashedIds.includes(hashedUserId);
      dispatch(updateUser(isUserValid));
      addToast(`Sláinte!`);
      navigate("/");

    } else {
      addToast(`Who the hell are you?`);
      dispatch(updateUser(false));
    }
  };

  return (
    <section className="loginPageContainer">
      <form onSubmit={login}>
        <input
          name="user"
          id="user"
          type="text"
          onChange={(e) => setUser(e.currentTarget.value)}
          placeholder="Enter username"
          value={user}
          autoComplete="off"
        />
        <div className="passInputContainer">
          <input
            name="pass"
            id="pass"
            type={passShow ? "text" : "password"}
            onChange={(e) => setPass(e.currentTarget.value)}
            placeholder="Enter password"
            value={pass}
            autoComplete="off"
          />
          <button
            type="button"
            className="showPassBtn"
            onClick={togglePass}
          >
            {passShow ? (
              <span className="material-symbols-outlined">visibility_off</span>
            ) : (
              <span className="material-symbols-outlined">visibility</span>
            )}
          </button>
        </div>
        <button type="submit">Log in</button>
      </form>
    </section>
  );
};

export default Login;
